const a = {
    less: "less than a minute read",
    default: "min read"
  },
  d = {
    less: "moins d'une minute de lecture",
    default: "min de lecture"
  },
  l = {
    less: "menos de un minuto leyendo",
    default: "min de lectura"
  },
  i = {
    less: "\u5C0F\u4E8E\u4E00\u5206\u949F",
    default: "\u5206\u949F"
  },
  r = {
    less: "1\u5206\u672A\u6E80\u306E\u8AAD\u307F\u53D6\u308A",
    default: "\u6700\u5C0F\u8AAD\u307F\u53D6\u308A"
  },
  c = {
    less: "weniger als eine Minute Lesezeit",
    default: "Min. Lesezeit"
  },
  m = {
    en: a,
    fr: d,
    es: l,
    cn: i,
    ja: r,
    de: c
  },
  A = ["en", "fr", "es", "cn", "ja", "de"],
  f = e => {
    var u;
    return (u = e.match(/[\w|\d|\s|,|.|\u00C0-\u024F|\u4E00-\u9FA5|\u3041-\u309F]+/giu)) != null ? u : [];
  },
  F = e => f(e).reduce((u, s) => u + (s.trim().length ? s.trim().split(/\s+/u).length : 0), 0),
  o = e => e < 1 + Number.EPSILON,
  g = function (e) {
    let u = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";
    return m[u][o(e) ? "less" : "default"];
  },
  E = function (e) {
    let u = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
    let s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en";
    const n = F(e),
      t = Number(Math.round(n / u).toFixed(2));
    return {
      minutes: t,
      words: n,
      text: `${o(t) ? "" : `${t} `}${g(t, s)}`
    };
  };
export { E as readingTime, A as supportedLanguages };